<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.code"
            :disabled="!formEditable || id"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-color-picker
            :validator="$v.form.color"
            :external-errors="errors['color']"
            :label-form="'Color' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            :value="form.color"
            :disabled="!formEditable"
            @change="$set(form, 'color', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.level"
            :external-errors="errors['level']"
            :label-form="'Level' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="number"
            :value="form.level"
            :disabled="!formEditable"
            @change="$set(form, 'level', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_PRIORITY_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'TaskPriorityEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Priority',
      rolePerm: 'tasks_taskpriority_retrieve',
      editRolePerm: 'tasks_taskpriority_update'
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].DETAIL.ACTIONS
    }),
    getFormData () {
      return Object.assign({}, this.form)
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      color: {},
      level: { required }
    }
  }
}
</script>
